import React from 'react';
import { FormattedMessage } from 'react-intl';

import SignupCta from 'app/features/migration/landing/components/SignupCta';
import Styled from 'app/features/migration/landing/components/HeroBlock.styled';
import Heading from 'app/components/layout/Heading.styled';
import Text from 'app/components/layout/Text.styled';
import Perks from 'app/features/migration/landing/components/Perks';
import RenewalNotice from 'app/features/couponCampaign/landing/components/RenewalNotice';
import PromotionRequirements from 'app/features/migration/landing/components/PromotionRequirements';

const UI = () => (
  <Styled.HeroBlock>
    <Styled.ImageWrapper>
      <Styled.Image
        src={`${window.etp.config.assetsUrl}img/migration/hero-bg.png`}
        srcSet={`${window.etp.config.assetsUrl}img/migration/hero-bg@2x.png 2x`}
        alt="Hero background"
      />
    </Styled.ImageWrapper>
    <Styled.BlackWrapper>
      <Styled.UpsellWrapper>
        <Styled.MigrationLogo
          src={`${window.etp.config.assetsUrl}img/migration/logo.png`}
          srcSet={`${window.etp.config.assetsUrl}img/migration/logo@2x.png 2x`}
          alt="Crunchyroll logo"
        />
        <Heading size="l" as={Styled.Title}>
          <FormattedMessage id="migration_landing_heroblock_title" />
        </Heading>
        <Text size="xl" as={Styled.SubTitle}>
          <FormattedMessage id="migration_landing_heroblock_subtitle" />
        </Text>
        <SignupCta />
        <RenewalNotice
          as={Styled.Notice}
          translationKey="migration_landing_renewal_notice"
        />
        <Perks />
        <PromotionRequirements />
      </Styled.UpsellWrapper>
    </Styled.BlackWrapper>
  </Styled.HeroBlock>
);

UI.displayName = 'Migration HeroBlock';

export { UI };

export default UI;
